export enum ReceiptStatus {
  Nuovo = 'Nuovo',
  InLavorazione = 'InLavorazione',
  Chiuso = 'Chiuso',
  Archiviato = 'Archiviato',
  Versato = 'Versato',
}

export const RECEIPT_STATUS_IN_PROGRESS: ReceiptStatus[] = [
  ReceiptStatus.Nuovo,
  ReceiptStatus.InLavorazione,
];

export enum ReceiptIncomeType {
  None = 'none',
  Cash = 'cash',
  Check = 'check',
}

export enum ReceiptCheckType {
  Bancario = 'bancario',
  Circolare = 'circolare',
  CircolareVersamentoContanti = 'circolareVersamentoContanti',
}

export enum InvoiceStatus {
  Open = 'open',
  Closed = 'closed',
}

export enum ReceiptType {
  Receipt = 'receipt',
  Worksheet = 'worksheet',
  Deposit = 'deposit',
}

export enum ReceiptStatementType {
  All = 'all',
  Open = 'open',
}

export interface SearchText {
  text?: string | null;
}

export interface OrderBy {
  propertyName: string;
  orderType: 'asc' | 'desc';
}

export interface ReceiptListSearch {
  searchText?: SearchText | null;
  orderBy?: OrderBy[] | null;
  searchObject: { statiIncasso: ReceiptStatus[] };
}

export interface ReceiptCashRow {
  id: string;
  taglioMoneta?: number | null;
  quantita?: number | null;
  importoMonete?: number | null;
  importo: number;
}

export interface ReceiptCheckRow {
  id: string;
  abi: string;
  cab: string;
  nomeBanca: string;
  numeroAssegno: string;
  dataAssegno?: string | null;
  tipoAssegno?: string | null;
  importo: number;
}

export interface Receipt {
  id: string;
  numeroIncasso: number;
  idBusinessPartner: string;
  ragioneSocialeCliente: string;
  zona: string;
  dataIncasso?: string | null;
  statoIncasso: ReceiptStatus;
  totaleValuta?: number | null;
  totaleAssegni?: number | null;
  totaleIncasso?: number | null;
  maxContanti?: number | null;
  contanti: ReceiptCashRow[];
  assegni: ReceiptCheckRow[];
}

export interface ReceiptList {
  items: Receipt[];
  totalItems: number;
}

export interface Invoice {
  id: string;
  status: InvoiceStatus;
  idDocumento: string;
  totale: number;
  acconto: number;
  importoAssegnato: number;
  scadenza?: string | null;
  dataSaldo?: string | null;
  dataEmissione?: string | null;
  descrizione: string;
}

export interface ReceiptInvoices {
  items: Invoice[];
  totalItems: number;
}

export interface BankBranch {
  abi: string;
  cab: string;
  banca: string;
}

export interface ReceiptStatementInfo {
  rischio: number;
  rischioAScadere: number;
  scaduto: number;
  aScadere: number;
}

export interface ReceiptStatementDetail {
  pagamento: number;
  redisuo: number;
  dataIncasso: string;
  metodo: ReceiptIncomeType;
}

export interface ReceiptStatement {
  fattura: string;
  totale: number;
  incassi: ReceiptStatementDetail[];
}

export interface ReceiptStatementRow {
  stato: string;
  dataDocumento: string;
  numeroDocumento: string;
  causale: string;
  numeroRiferimento: number;
  dataScadenza: string;
  importo: number;
  dareAvere: string;
  residuo: number;
  metodo: ReceiptIncomeType;
}

export interface ReceiptStatementInvoice {
  codiceCliente: number;
  numeroRiferimento: number;
  fattura: string;
  totale: number;
  saldoPartita: number;
  aperta: boolean;
  dataScadenza: string;
  stato: string;
  righe: ReceiptStatementRow[];
}

export interface ReceiptStatementCustomerBalance {
  codiceCliente: number;
  saldo: number;
}

export interface ReceiptStatementList {
  partite: ReceiptStatementInvoice[];
  saldiPerCodiceCliente: ReceiptStatementCustomerBalance[];
  saldoCliente: number;
  // TODO: items verrà rimosso dalla risposta
  items: ReceiptStatement[];
  totalItems: number;
}

export interface ReceiptStatementSearch {
  tipo: ReceiptStatementType;
}

export interface ReceiptsSummaryEntry {
  receiptType: ReceiptType;
  count: number;
}

export interface ReceiptsSummary {
  receipts: ReceiptsSummaryEntry[];
}


export interface CashLine {
  taglio: number;
  quantita: number;
}

export interface ReceiptCashInput {
  righe: CashLine[];
  importoMonete: number;
}

export interface ReceiptCheckInput {
  idAssegno?: string | null;
  abi: string;
  cab: string;
  numeroAssegno: string;
  banca: string;
  importo: number;
  data: Date | null;
  tipo: ReceiptCheckType | null;
}

export interface ReceiptAdvance {
  codiceClienteErp: string;
  tipo: 'OIL' | 'NONOIL';
  importo: number;
}

export interface ReceiptIncome {
  incomeType: ReceiptIncomeType;
  cash: ReceiptCashInput | null;
  check: ReceiptCheckInput | null;
  acconti: ReceiptAdvance[];
}


export interface ReceiptCashRequest {
  righe: { taglioMoneta: number; quantita: number }[];
  importoMonete: number;
}

export interface ReceiptCheckRequest {
  idAssegno?: string;
  abi: string;
  cab: string;
  nomeBanca: string;
  numeroAssegno: string;
  dataAssegno: string;
  tipoAssegno: string | null;
  importo: number;
}

export interface RegisterReceiptPayload {
  idIncasso: string | null;
  idBusinessPartner: string;
  contanti?: ReceiptCashRequest;
  assegno?: ReceiptCheckRequest;
}

export interface RegisterReceiptResponse {
  idIncasso: string | null;
}

export interface ConfirmReceiptResponse {
  emailInviata?: boolean;
  emailDestinatario?: string | null;
}
